import { DevExpressMap } from "./DevExtremeMap";
import { RevenuePrices } from "./RevenuePrices";
import { TemplateColors, Templates } from "./Templates";

/**Charts used by revenue prices */
export class Charts
{
	private _parent: RevenuePrices;

	/**
	 * Constructor for charts used in revenue price application
	 * @param parent parent object that runs the application
	 */
	constructor(parent: RevenuePrices)
	{
		this._parent = parent;
	}

	/**
	 * Setting up our map visualization
	 */
	SetMap()
	{
		$('#' + Templates.Ids.vectorMapContainer).dxVectorMap({
			background: {
				borderColor: ""
			},
			layers: {
				name: "areas",
				dataSource: DevExpressMap.usa,
				hoveredColor: TemplateColors.nauBlue,
				hoveredBorderColor: "",
				selectedColor: TemplateColors.nauBlue,
				selectedBorderColor: "",
				selectedBorderWidth: 1,
				customize: (elements) =>
				{
					// If we eventually have the states filtered by year, on map reinitialization any states added to the blacklist would be unclickable 
					$.each(elements, (_, element) =>
					{
						var blacklistedState = (this._parent._blacklistedStates) ? (this._parent._blacklistedStates.indexOf(element.attribute('name')) !== -1) : null;
						if (blacklistedState)
						{
							element.applySettings({
								color: TemplateColors.disabledState,
								hoveredColor: TemplateColors.disabledState,
								selectedColor: null
							});
						}
					});
				}
			},
			onClick: (e) =>
			{
				var clickedArea = e.target;
				if (clickedArea !== undefined && clickedArea.layer.type === 'area')
				{
					// if there's no blacklisted states we continue, otherwise we check to see if the current selection is on the list
					if (!this._parent._blacklistedStates || this._parent._blacklistedStates.indexOf(clickedArea.attribute('name')) === -1)
					{
						let currentSelections = this._parent._priceDefinitionForm.GetCurrentSelections();
						currentSelections.State = clickedArea.attribute('name');
						this._parent._priceDefinitionForm.SetNewValues(currentSelections);
					}
					else
					{
						$('#' + Templates.Ids.unsupportedStatePopup).dxPopup("show");
						$('#' + Templates.Ids.unsupportedStateText).text('NAU does not currently support price discovery in ' + clickedArea.attribute('name'));
					}
				}
			},
			center: [-95, 38],
			zoomFactor: 10,
			zoomingEnabled: false,
			panningEnabled: false
		});
	}

	/**
	 * setting up the main chart for the modal
	 * @param datasource data source
	 * @param title title of grid
	 * @param exchange exchange value
	 * @param month month value
	 */
	SetChart(datasource, title, exchange, month)
	{
		$('#' + Templates.Ids.popupRevenuePricesChart).dxChart({
			dataSource: datasource,
			commonSeriesSettings: {
				argumentField: "dateOfPrice",
				point: {
					visible: false
				}
			},
			// Using a combination of area and spline type charts
			series: [
				{ type: "area", valueField: "highPrice", name: "Highest", stack: "highPrice", color: TemplateColors.nauBlue, hoverMode: "none" },
				{ type: "spline", valueField: "closingPrice", name: "Closing", stack: "closingPrice", color: TemplateColors.nauGrey, hoverMode: "none" },
				{ type: "spline", valueField: "lowPrice", name: "Lowest", stack: "lowPrice", color: TemplateColors.nauOrange, hoverMode: "none" },

			],
			legend: {
				visible: false
			},
			valueAxis: {
				label: {
					customizeText: (e) =>
					{
						if (e.valueText != undefined)
						{
							return "$" + parseFloat(e.valueText).toFixed(2);
						}

						return "";
					}
				},
				position: 'left',
				valueMarginsEnabled: true,
			},
			argumentAxis: {
				type: 'discrete'
			},
			"export": {
				// We're not showing the print or image options on mobile/embedded
				enabled: !this._parent.isEmbedded
			},
			title: title,
			tooltip: {
				enabled: true,
				shared: true,
				customizeTooltip: (info) =>
				{
					return {
						html:
							"<div><div class='tooltip-header'>" +
							info.argumentText + "</div>" +
							"<div class='tooltip-body'><div class='value-text'>" +
							this.ToolTipDataParser(info.valueText) +
							" </div></div></div>"
					};
				}

			},
			onDrawn: () =>
			{
				$('#' + Templates.Ids.popupRevenuePricesChart).dxChart('render');
			}
		});

		var renderOptions = {
			force: true,
			animate: false,
			asyncSeriesRendering: false
		};

		// making sure the print/image download button doesn't show on mobile
		$('.dx-export-menu-button').addClass('hidden-xs');

		$('#' + Templates.Ids.popupMonthDiv).text(month);
		$('#' + Templates.Ids.popupExchangeDiv).text(exchange);
		var chart = $('#' + Templates.Ids.popupRevenuePricesChart).dxChart('instance');
		chart.render(renderOptions);

		$('#' + Templates.Ids.revenuePriceGraph).dxPopup("show");
	}

	/**
	 * Tool tip template to display over chart
	 * @param valueText value to display
	 */
	ToolTipDataParser (valueText: string)
	{
		// Example string: "Highest: 3.9025 Closing: 3.8975 Lowest: 3.87"
		var valuesSplit = valueText.split(/\s+/);
		var highestText = " Highest";
		var highestValue = window.NauUtility.stringOps.formatCurrency(valuesSplit[1]);
		var lowestText = " Lowest";
		var lowestValue = window.NauUtility.stringOps.formatCurrency(valuesSplit[5]);
		var closingText = " Closing";
		var closingValue = window.NauUtility.stringOps.formatCurrency(valuesSplit[3]);
		var responseString =
			"<table class='tool-tip-table'><tr><td class='tooltip-value-label'><div class='line-color-square blue'/>" + highestText + "</td><td class='tooltip-value'>" + highestValue + "</td></tr>" +
			"<tr><td class='tooltip-value-label'><div class='line-color-square orange'/>" + lowestText + "</td><td class='tooltip-value'>" + lowestValue + "</td></tr>" +
			"<tr><td class='tooltip-value-label'><div class='line-color-square grey'/>" + closingText + "</td> <td class='tooltip-value'>" + closingValue + "</td></tr ></table> ";

		return responseString;
	}

	/**
	 * Spark line tool tip to show when hovering over spark lines
	 * @param valueText value to display
	 */
	SparkLineTooltip (valueText: string)
	{
		var openingText = " Opening";
		var openingValue = window.NauUtility.stringOps.formatCurrency(valueText[1]);
		var highestText = " Highest";
		var highestValue = window.NauUtility.stringOps.formatCurrency(valueText[7]);
		var lowestText = " Lowest";
		var lowestValue = window.NauUtility.stringOps.formatCurrency(valueText[5]);
		var closingText = " Closing";
		var closingValue = window.NauUtility.stringOps.formatCurrency(valueText[3]);
		var responseString =
			"<table class='tool-tip-table'><tr><td class='tooltip-value-label'><div class='line-color-square grey'/>" + openingText + "</td> <td class='tooltip-value'>" + openingValue + "</td></tr>" +
			"<tr><td class='tooltip-value-label'><div class='line-color-square blue'/>" + highestText + "</td><td class='tooltip-value'>" + highestValue + "</td></tr>" +
			"<tr><td class='tooltip-value-label'><div class='line-color-square orange'/>" + lowestText + "</td><td class='tooltip-value'>" + lowestValue + "</td></tr>" +
			"<tr><td class='tooltip-value-label'><div class='line-color-square grey'/>" + closingText + "</td><td class='tooltip-value'>" + closingValue + "</td></tr></table> ";

		return responseString;
	}
}